var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.861 5.99v2.604c0 .431-.35.781-.781.781H.78C.35 9.375 0 9.025 0 8.594V5.99c0-.432.35-.782.781-.782H4.08c.431 0 .781.35.781.782zM0 11.198v2.604c0 .432.35.781.781.781H4.08c.431 0 .781-.35.781-.78v-2.605c0-.432-.35-.781-.781-.781H.78c-.431 0-.781.35-.781.78zM4.08 0H.78C.35 0 0 .35 0 .781v2.604c0 .432.35.782.781.782H4.08c.431 0 .781-.35.781-.782V.781C4.861.35 4.511 0 4.08 0zm2.604 14.583h9.201c.432 0 .782-.35.782-.78v-2.605c0-.432-.35-.781-.782-.781H6.684c-.431 0-.781.35-.781.78v2.605c0 .432.35.781.781.781zM5.903.781v2.604c0 .432.35.782.781.782h9.201c.432 0 .782-.35.782-.782V.781c0-.431-.35-.781-.782-.781H6.684c-.431 0-.781.35-.781.781zm.781 8.594h9.201c.432 0 .782-.35.782-.781V5.99c0-.432-.35-.782-.782-.782H6.684c-.431 0-.781.35-.781.782v2.604c0 .431.35.781.781.781z",
    transform: "translate(-1324 -81) translate(1286 75) translate(38 6) translate(1.667 2.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.b64578d45d23c131b1de839e4cba36fc.svg";
export { ForwardRef as ReactComponent };